import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { OverlayView } from '@react-google-maps/api'
import styles from './MapMarker.module.css'

const getMarkerColor = (type) => {
  switch (type) {
    case 'completed_program':
      return '#DA251D'

    case 'ongoing_program':
      return '#FF5448'

    case 'organization':
    default:
      return '#DA251D'
  }
};

const getMarkerSize = (total, type) => {
  let size;

  if (total >= 20) {
    size = 'large';
    // size = 28
  } else if (total >= 11 && total < 20) {
    size = 'medium';
    // size = 20
  } else {
    size = 'small';
    // size = 12
  }

  if (type === 'ongoing_program') {
    // size = 6
    size = 'small';
  }

  return size
}

// Regular Marker Shape
const RegularMarkerShape = ({ data }) => {
  const size = getMarkerSize(data.total, data.markerType)
  const bg = getMarkerColor(data.markerType)

  return (
    <div className={`${styles['khub-map-marker__icon']} ${styles[`marker-size--${size}`]} ${styles[`marker-type--${data.markerType}`]} flex items-center justify-center`}>
      <div style={{ backgroundColor: bg }} className={styles['khub-map-marker__bg']}></div>
      { data.places && <div className={styles['khub-map-marker__plus']}>+</div> }
    </div>
  )
}

// Special marker shape for program with ongoind and completed
const ProgramMarkerShape = ({ data }) => {
  const size = getMarkerSize(data.total, data.markerType)
  const bg = getMarkerColor('completed_program')
  const innerBg = getMarkerColor('ongoing_program')

  return (
    <div className={`${styles['khub-map-marker__icon']} ${styles[`marker-size--${size}`]} ${styles[`marker-type--${data.markerType}`]} flex items-center justify-center`}>
      <div style={{ backgroundColor: bg }} className={styles['khub-map-marker__bg']}></div>
      <div style={{ backgroundColor: innerBg }} className={styles['khub-map-marker__ongoing-program']}></div>
      { data.places && <div className={styles['khub-map-marker__plus']}>+</div> }
    </div>
  )
}

// Special marker shape for headquerters
const HeadquarterMarkerShape = ({ data }) => {
  return (
    <div className={`${styles['khub-map-marker__icon']} ${styles['marker-type--headquarter']} flex items-center justify-center`}>
      <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.598 5.854c.599-1.843 3.205-1.843 3.804 0l1.129 3.474a2 2 0 001.902 1.382h3.653c1.938 0 2.743 2.48 1.176 3.618l-2.956 2.147a2 2 0 00-.726 2.236l1.129 3.475c.598 1.842-1.51 3.375-3.078 2.236l-2.955-2.147a2 2 0 00-2.352 0l-2.955 2.147c-1.567 1.139-3.676-.394-3.078-2.236l1.13-3.474a2 2 0 00-.727-2.237l-2.956-2.147c-1.567-1.138-.761-3.618 1.176-3.618h3.653a2 2 0 001.902-1.382l1.129-3.474z" fill="#2BB36F" fillOpacity=".75"/>
      </svg>
    </div>
  )
}

// The Marker Component
const MapMarker = ({ data, isActive, onClick, onMobileClick, onMouseOver, onMouseOut }) => {
  const viewEl = useRef(null)
  const onHover = () => {
    // setIsOpen(true)
    onMouseOver(data)
  }

  const onHoverOut = () => {
    // setIsOpen(false)
    onMouseOut(data)
  }

  const onLoad = () => {
    // Prevent button on for mobile from bubbling to the map,
    // so the when button clicked, it won't trigger the map click event
    // eslint-disable-next-line no-undef
    google.maps.OverlayView.preventMapHitsFrom(viewEl.current)
  }

  return (
    <React.Fragment>
      <OverlayView
        position={data.coordinate}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        onLoad={onLoad}
      >
        <React.Fragment>
          <button
            ref={viewEl}
            onClick={(event) => onMobileClick(event, data)}
            style={{ outline: 0 }}
            className={`lg:hidden ${styles['khub-map-marker']} ${styles[`khub-map-marker--${data.markerType}`]} ${isActive ? styles.active : ''}`}
          >
            { data.markerType === 'program' && <ProgramMarkerShape data={data} /> }
            { data.markerType === 'headquarter' && <HeadquarterMarkerShape data={data} /> }
            { (data.markerType !== 'program' && data.markerType !== 'headquarter') && <RegularMarkerShape data={data} />}
          </button>
          <button
            onClick={(event) => onClick(event, data)}
            onMouseOver={onHover}
            onMouseOut={onHoverOut}
            style={{ outline: 0 }}
            className={`hidden lg:block ${styles['khub-map-marker']} ${styles[`khub-map-marker--${data.markerType}`]} ${isActive ? styles.active : ''}`}
          >
            { data.markerType === 'program' && <ProgramMarkerShape data={data} /> }
            { data.markerType === 'headquarter' && <HeadquarterMarkerShape data={data} /> }
            { (data.markerType !== 'program' && data.markerType !== 'headquarter') && <RegularMarkerShape data={data} />}
          </button>
        </React.Fragment>
      </OverlayView>
    </React.Fragment>
  )
}

MapMarker.propTypes = {
  data: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onMobileClick: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
}

MapMarker.defaultProps = {
  isActive: false,
  onMouseOver: () => {},
  onMouseOut: () => {},
}

export { MapMarker }
